'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_LABELKEY = exports.DEFAULT_LABELKEY = 'label';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/lib/constants/defaultLabelKey.js
// module id = 214
// module chunks = 0